import { Modal as ModalModule } from 'common';
import React from 'react';

const { Modal, ModalButtonActionType } = ModalModule;

const parseDescription = description => {
	const splitText = description.split('  ').filter(text => text !== '');

	return splitText.map((text, i) => <p key={i + text}>{text}</p>);
};

const parseGBBDescription = description => {
	// split text by double space and remove empty strings
	const splitText = description.split('\n   ').filter(text => text !== '');
	// remove first element
	splitText.shift();

	// return each feature and replace '-' with bullet point
	return splitText.map((text, i) => (
		<p key={i} className="text">
			{text.replace('-', '\u2022')}
		</p>
	));
};

const renderPlanDetails = (title, description) => {
	if (title) {
		return (
			<>
				<h1 className="title">{title}</h1>
				<p className="key-features">Key features of {title}:</p>
				{parseGBBDescription(description)}
			</>
		);
	} else {
		return parseDescription(description);
	}
};

const PlanDetailsModal = ({ data: { title, description }, modalId }) => (
	<Modal
		modalId={modalId}
		className="account-change-plan plan-details-modal"
		header="Plan Details"
		primaryButton={{
			type: ModalButtonActionType.Ok,
			text: 'OK',
		}}
		size="small"
	>
		<div className="body">{renderPlanDetails(title, description)}</div>
	</Modal>
);

export default PlanDetailsModal;
